import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { FailureType } from 'app/core/device/failures/failure-type';
import { TableWidgetComponent } from 'app/modules/admin/common/table-widget/table-widget.component';
import { TableComponent } from 'app/modules/admin/common/table/table.component';
import { DeviceFailure } from 'app/modules/admin/overview/company-devices-failures-widget/device-failure';
import {
    DeviceFailuresService
} from 'app/modules/admin/overview/company-devices-failures-widget/device-failures.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-company-devices-failures-widget',
  standalone: true,
  imports: [TableWidgetComponent, TranslocoDatePipe],
  templateUrl: './company-devices-failures-widget.component.html',
  styleUrl: './company-devices-failures-widget.component.scss',
  providers: [TranslocoDatePipe]
})
export class CompanyDevicesFailuresWidgetComponent implements OnChanges {
    @Input() companyId!: number;
    @Input() loading: boolean = false;
    @Output() loadingChange = new EventEmitter<boolean>();

    @ViewChild('widget') widget!: TableComponent<DeviceFailure>;

    columns = [
        {
            header: 'Type',
            name: 'type.id',
            minWidth: '50px',
            maxWidth: '70px',
            type: 'icon-failure',
            value: (value: any, row: DeviceFailure) => this.getTypId(value, row)
        },
        {
            header: 'Description',
            name: 'type.errorType',
            type: 'text',
            value: (value: any, row: DeviceFailure) => this.getErrorDescription(value, row)
        },
        {
            header: 'Device',
            name: 'machine.deviceName',
            type: 'text',
            value: (value: any, row: DeviceFailure) => this.getDeviceName(value, row)
        },
        {
            header: 'Start date',
            name: 'alarmActivationTimestamp',
            minWidth: '100px',
            maxWidth: '100px',
            type: 'datetime',
            value: (value: any, row: DeviceFailure) => this.getStartDateMac(value, row)
        },
        {
            header: 'End date',
            name: 'alarmDeactivationTimestamp',
            minWidth: '100px',
            maxWidth: '100px',
            type: 'text',
            value: (value: any, row: DeviceFailure) => this.getEndDateMac(value, row)
        }
    ];

    constructor(
        private _deviceFailuresService: DeviceFailuresService,
        private _translocoService: TranslocoService,
        private _datePipe: TranslocoDatePipe
    ) {
    }

    dataLoaderWidgetDeviceFailures = (page: number, size: number, sort: string, order: 'asc' | 'desc' | '', search?: string) => {
        this.loading = true;
        this.loadingChange.emit(true);
        return this._deviceFailuresService.getCompanyDevicesFailures(
            this.companyId,
            null,
            null,
            null,
            null,
            page,
            size
        ).pipe(
            finalize(() => {
                this.loading = false;
                this.loadingChange.emit(false);
            })
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['companyId']) {
            this.widget?.loadData();
        }
    }

    // TODO: Allow table to get the value directly from nested properties, ex: machine.deviceName.
    getTypId(value: string, row: DeviceFailure) {
        return row.type.id;
    }

    getErrorDescription(value: string, row: DeviceFailure) {
        return this._translocoService.translate(FailureType.getFailureTypeDescription(row.type.id));
    }

    getAlarmActivation(value: string, row: DeviceFailure) {
        return row.alarmActivationTimestamp;
    }

    getDeviceName(value: string, row: DeviceFailure) {
        return row.machine.deviceName;
    }

    getDeviceMac(value: string, row: DeviceFailure) {
        return row.machine.mac;
    }

    getStartDateMac(value: string, row: DeviceFailure) {
        return row.alarmActivationTimestamp;
    }

    getEndDateMac(value: string, row: DeviceFailure): string {
        return row.alarmDeactivationTimestamp
        ? this._datePipe.transform(row.alarmDeactivationTimestamp, { dateStyle: 'short', timeStyle: 'short' })
        : '-'
    }
}
